import Activate from './activate-container';

export default Activate;
